import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export interface MarketSelectionEntry {
  name?: string | null;
  description?: string | null;
}

export interface MarketEntry {
  name?: string | null;
  description?: string | null;
  selection?: Record<string, MarketSelectionEntry | null> | null;
}

export type MarketTranslations = Record<string, Record<string, MarketEntry | null> | null>;

@Injectable({ providedIn: 'root' })
export class MarketI18nService {
  private readonly http = inject(HttpClient);
  private readonly locale = 'en';

  readonly translations = signal<MarketTranslations | null>(null);
  private loadStarted = false;

  load(): void {
    if (this.loadStarted) {
      return;
    }
    this.loadStarted = true;

    this.http
      .get<MarketTranslations>(`${environment.waCmsServiceUrl}/api/v1/markets/all/${this.locale}`)
      .subscribe({
        next: (data) => this.translations.set(data ?? {}),
        error: (err) => {
          console.warn('[MarketI18nService] Failed to load market translations', err);
          this.translations.set({});
        },
      });
  }

  marketName(sportId: string | null | undefined, marketCode: string | null | undefined): string {
    const code = (marketCode ?? '').trim();
    if (!code) {
      return '';
    }
    const sport = (sportId ?? '').trim();
    const data = this.translations();
    const entry = data?.[sport]?.[code] ?? null;
    const name = entry?.name?.trim();
    return name || code;
  }

  selectionName(
    sportId: string | null | undefined,
    marketCode: string | null | undefined,
    selectionCode: string | null | undefined,
  ): string {
    const code = (selectionCode ?? '').trim();
    if (!code) {
      return '';
    }
    const sport = (sportId ?? '').trim();
    const market = (marketCode ?? '').trim();
    const data = this.translations();
    const entry = data?.[sport]?.[market]?.selection?.[code] ?? null;
    const name = entry?.name?.trim();
    return name || code;
  }
}
